import * as React from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { SliderModalLoadable, TSliderModalProps } from './loadable';
import { NewbuildingCompareFlightBanner } from '../../components/NewbuildingCompareFlightBanner';

type TSlides = TSliderModalProps['slides'];

const SLIDES_CONFIG_KEY = 'Newbuilding.CompareFlightTrap.Slides';

const SLIDES_DEFAULT: TSlides = [
  {
    type: 'info',
    imageUrl: 'https://static.cdn-cian.ru/frontend/newbuilding-b2c-assets/compare-flight/1.png',
    title: 'Встречайте сравнение ЖК',
    description: 'Нажимайте плюс — соберём таблицу с выводами в разделе «Сравнение»',
  },
  {
    type: 'info',
    imageUrl: 'https://static.cdn-cian.ru/frontend/newbuilding-b2c-assets/compare-flight/2.png',
    title: 'Таблица со всем важным',
    description: 'Цены, метраж, что есть на территории и многое другое',
  },
  {
    type: 'info',
    imageUrl: 'https://static.cdn-cian.ru/frontend/newbuilding-b2c-assets/compare-flight/3.png',
    title: 'Итоги сравнения от ИИ',
    description: 'Подчеркнём отличия и особенности',
  },
];

export const NewbuildingCompareFlightBannerContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const slides = config.get<TSlides>(SLIDES_CONFIG_KEY) ?? SLIDES_DEFAULT;

  const handleButtonClick = React.useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleModalClose = React.useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <NewbuildingCompareFlightBanner onButtonClick={handleButtonClick} />

      {isModalOpen && <SliderModalLoadable slides={slides} onClose={handleModalClose} />}
    </>
  );
};
